import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "../../components";
import { UpdateUserPassword } from "../../utilities/api/user/user-service";
import { messages } from "../../utilities/Messages";
const getMessage = messages.resetPassword;


const ReGeneratePassord = ({ regeneratePassword, setRegeneratePassword, id, }: any) => {
  const [password, setPassword] = useState("")
  const [conPassword, setConPassword] = useState("")
  const [message, setMessage] = useState("")
  const navigate = useNavigate()
  const [buttonDisable, setButtonDisable] = useState(false)

  const ReGenerate = async () => {
    setButtonDisable(true)
    const result = await UpdateUserPassword(password, id)
    if (result.status === 200) {
      navigate("/user-info")
      setMessage("")
      setRegeneratePassword(false)
    } else {
      setMessage(result.response.data.message)
    }
    setButtonDisable(false)
  }
  const handleClick = () => {
    if (/^\S+$/.test(password) && password.length >= 8 && password.length <= 16 && password === conPassword) {
      ReGenerate()
    } else if (password.length < 8 || password.length > 16) {
      setMessage(getMessage.password_min_max_length)
    } else if (!/^\S+$/.test(password)) {
      setMessage(getMessage.password_isNotContainSpace)
    } else {
      setMessage(getMessage.password_match)
    }
  }

  return (
    <Modal
      show={regeneratePassword}
      onHide={() => setRegeneratePassword(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="regenerate-password"
    >
      <Modal.Header className="border-0 pb-0 pb-2" closeButton>
        <Modal.Title id="contained-modal-title-vcenter fw-semibold">
          Re-Generate Password
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3 text-start">
          <label htmlFor="password" className="form-label">
            Password <small className="text-danger">*</small>
          </label>
          <Input
            onChange={(e: any) => setPassword(e.target.value)}
            type="password"
            placeholder="Enter Password"
            id="password"
            name="password"
            className="form-control"
          />
        </div>
        <div className="mb-3 text-start">
          <label htmlFor="cpassword" className="form-label">
            Confirm Password <small className="text-danger">*</small>
          </label>
          <Input
            onChange={(e: any) => setConPassword(e.target.value)}
            type="password"
            placeholder="Enter Confirm Password"
            id="cpassword"
            name="cpassword"
            className="form-control"
          />
          <label htmlFor="password" className="error-msg">
            {message}
          </label>
        </div>
        <div className="text-end">
          <Button
            disabled={buttonDisable}
            onClick={handleClick}
            type="button"
            bname={buttonDisable ? "Submitting" : "Submit"}
            name="submit"
            id="submit"
            className="btn btn-primary rounded-1 mt-1"
          ></Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}
export { ReGeneratePassord }